/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetOrgInvitesOptions, AdminGetOrgInvitesResponses } from '../../models/AdminGetOrgInvites'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get all outstanding org invitations.
 * @summary Get Org Invites
 * {@link /admin/org/:org_id/invites}
 */
export function adminGetOrgInvites<ThrowOnError extends boolean = true>(options: Options<AdminGetOrgInvitesOptions, ThrowOnError>): Promise<UnwrappedResult<AdminGetOrgInvitesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/org/{org_id}/invites', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetOrgInvitesResponses, ThrowOnError>>
}
